module.exports = __webpack_public_path__ + "static/media/background_1.4c71b657.jpg";